import { useState } from 'react';
import { Button, Row, Col } from 'antd';
import { FiArrowLeftCircle, FiArrowRight, FiArrowRightCircle, FiArrowUp, FiPlus } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';


export const Results = () => {

        const navigate = useNavigate();

        const reviews = [
                {
                        name:   "Michael Broadbridge",
                        company: "Fun Cases",
                        image:  "reviews/fun-cases.jpeg",
                        review: "Service has been outstanding in producing and maintaining our social media ads. They didn’t just hit our target ROAS, they smashed it by a mile."
                },
                {
                        name:   "Chris Jakeways",
                        company: "Vanaways",
                        image:  "reviews/vanaways.jpeg",
                        review: "These guys know their stuff! Finding Bigg has made a massive difference to our business and helped to make us one of the country's largest suppliers of Vans."
                },
                {
                        name:   "Kirsty McNeil",
                        company: "Western Global",
                        image:  "reviews/western-global.jpeg",
                        review: "We have worked with these guys since 2019, at first with the UK side of our business, however they now partner with us for our US growth market."
                },
                {
                        name:   "Maxim Lyashco",
                        company: "ICS",
                        image:  "reviews/ics.jpeg",
                        review: "I'm more than happy not only with the quality of their work but also with their customer support. The communication from the team has been excellent."
                },
                
        ]
        const [ reviewNumber, setReviewNumber ] = useState(0)

        const changeReview = (i) => {

                let newReviewNumber = reviewNumber + i

                if (newReviewNumber > reviews.length - 1) {
                        newReviewNumber = 0
                } else if (newReviewNumber < 0) {
                        newReviewNumber = reviews.length -1
                }

                setReviewNumber(newReviewNumber)

                
        }

        const reviewItem = () => {

                const r = reviews[reviewNumber]

                return (
                        <div className="section grey" style={{paddingTop: 100, paddingBottom: 100}}>
                                <div className="container thin">
                                        <div className="review">
                                                <h2 style={{textAlign: 'center'}}>What our clients say</h2>
                                                <Row gutter={15} display="flex" justify={"center"}>
                                                        <Col sm={8}>
                                                                <div style={{textAlign: 'center'}}>
                                                                        <div className="review-image">
                                                                                <img src={`/images/${r.image}`} alt="review"/>
                                                                        </div>
                                                                        <div className="reviewArrow" onClick={() => changeReview(-1)}>
                                                                                <FiArrowLeftCircle size={50} color={"#fff"} fill={"#000"} />
                                                                        </div>
                                                                        <div className="reviewArrow"onClick={() => changeReview(1)}>
                                                                                <FiArrowRightCircle size={50} color={"#fff"} fill={"#000"} />
                                                                        </div>
                                                                        
                                                                </div>
                                                        </Col>
                                                        <Col sm={15} offset={1}>
                                                                
                                                                
                                                                
                                                                <div className="review-name">
                                                                        {r.name}
                                                                </div>
                                                                <div className="review-company">
                                                                        {r.company}
                                                                </div>
                                                                <p className="reviewText">
                                                                        “{r.review}”
                                                                </p>
                                                                <div className="quoteMark">
                                                                        "
                                                                </div>
                                                        
                                                        </Col>
                                                        <Col sm={4}>
                                                                
                                                        </Col>
                                                </Row>
                                        </div>
                                </div>
                        </div>
                )
        }

        const banner = () => {

                return (
                        <div id="builder-banner">
                                <div className="container">
                                        {/* <Row gutter={15} align="middle">
                                                <Col sm={24}>
                                                        <div className="heroText">
                                                                <h1>Package Builder</h1>
                                                                <h4>Answer the questions below to build your custom SmartPromote package</h4>
                                                        </div>
                                                </Col>
                                               
                                        </Row> */}
                                        
                                        
                                        
                                </div>
                        </div>
                )
        }
        
        const headline = () => {

                return (
                        <div style={{paddingBottom: 50}}>
                                <div className="section grey">
                                <div className="container">
                                        <Row gutter={15} align="middle">
                                                <Col sm={24}>
                                                        <div className="heroText" style={{textAlign: 'center'}}>
                                                                <h1>Human-Delivered, AI-Enhanced Business Growth</h1>
                                                                <h4 style={{maxWidth: 800, lineHeight: '26px', margin: '0 auto'}}>
                                                                        Since 2006 we've been delivering results that really make a difference, helping to grow thousands of 
                                                                        businesses in hundreds of sectors along the way.
                                                                </h4>
                                                        </div>
                                                       
                                                </Col>
                                                <Col sm={24}>
                                                        
                                                        <div style={{textAlign: 'center', marginTop: 50}}>
                                                                <Button onClick={() => navigate('/builder')} style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                }} type="primary">Build your package <FiArrowRight style={{marginLeft: 5}}/> </Button>
                                                                <Button type="blackoutline">Get in touch</Button>
                                                        </div>
                                                </Col>
                                        </Row>

                                        <div className="resultSection">
                                        <Row gutter={30}>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Vanaways</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">80%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://amcdn.blob.core.windows.net/media/1/root/vanaways-new-office_w555_h555.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Willow Letting</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">93%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://scontent-lhr6-1.xx.fbcdn.net/v/t39.30808-6/303977319_492356109564808_3423128230842681145_n.png?_nc_cat=109&ccb=1-7&_nc_sid=783fdb&_nc_ohc=aFep4L2czI4AX87aiyC&_nc_ht=scontent-lhr6-1.xx&oh=00_AfDB77Le0yoOGztoziBewPYXUdMOrz3YavvLSlfAogVSGQ&oe=65D24166)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Fun Cases</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">73%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://webgro.co.uk/wp-content/uploads/2023/10/fun-cases.png)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Johnsons Stalbridge</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">22.1K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://www.johnsons-stalbridge.com/assets/cache/images/gemma/linen_hire%281%29-1024x550-ab7.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Trip Abrood</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">87%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://ik.imgkit.net/3vlqs5axxjf/PCWW/uploadedImages/Articles/News/2021/April/tripabroodfunding.jpeg?tr=w-800%2Ch-400%2Cfo-auto)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Lazudi</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">67K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://images.squarespace-cdn.com/content/v1/6051d02616f58d6b0b8ad52f/8028e9c5-a825-4159-ad63-236268b28ecf/iStock-984661764.jpg?format=2500w)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>

                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Western Global</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">22%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://western-global.com/wp-content/uploads/2021/07/Bristol_1962-768x384.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Hanne &amp; Co</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">72K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://d1d8vslyhr7rdg.cloudfront.net/Pictures/780xany/0/9/2/112092_hannelandscape_795987.jpeg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Vanango</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">19%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://vanango.co.uk/images/manage-your-fleet/new-car-vehicle-dealership.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>

                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Vanaways</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">80%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://amcdn.blob.core.windows.net/media/1/root/vanaways-new-office_w555_h555.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Willow Letting</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">93%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://scontent-lhr6-1.xx.fbcdn.net/v/t39.30808-6/303977319_492356109564808_3423128230842681145_n.png?_nc_cat=109&ccb=1-7&_nc_sid=783fdb&_nc_ohc=aFep4L2czI4AX87aiyC&_nc_ht=scontent-lhr6-1.xx&oh=00_AfDB77Le0yoOGztoziBewPYXUdMOrz3YavvLSlfAogVSGQ&oe=65D24166)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Fun Cases</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">73%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://webgro.co.uk/wp-content/uploads/2023/10/fun-cases.png)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Johnsons Stalbridge</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">22.1K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://www.johnsons-stalbridge.com/assets/cache/images/gemma/linen_hire%281%29-1024x550-ab7.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Trip Abrood</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">87%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://ik.imgkit.net/3vlqs5axxjf/PCWW/uploadedImages/Articles/News/2021/April/tripabroodfunding.jpeg?tr=w-800%2Ch-400%2Cfo-auto)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Lazudi</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">67K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://images.squarespace-cdn.com/content/v1/6051d02616f58d6b0b8ad52f/8028e9c5-a825-4159-ad63-236268b28ecf/iStock-984661764.jpg?format=2500w)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Western Global</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">22%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://western-global.com/wp-content/uploads/2021/07/Bristol_1962-768x384.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Hanne &amp; Co</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiPlus /></div>
                                                                                <div className="no">72K</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://d1d8vslyhr7rdg.cloudfront.net/Pictures/780xany/0/9/2/112092_hannelandscape_795987.jpeg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                                <Col sm={8}>
                                                        <div className="result">
                                                                <div className="content">
                                                                        <div className="name">Vanango</div>
                                                                        <div className="number">
                                                                                <div className="icon"><FiArrowUp /></div>
                                                                                <div className="no">19%</div>
                                                                        </div>
                                                                        <div className="description">Increase in sales from all sources in under 6 months</div>
                                                                </div>
                                                                <div className="image" style={{backgroundImage: 'URL(https://vanango.co.uk/images/manage-your-fleet/new-car-vehicle-dealership.jpg)'}}>
                                                                        
                                                                </div>
                                                        </div>
                                                </Col>
                                        </Row>
                                        </div>
                                        
                                </div>
                        </div>
                        </div>
                )
        }

        

        const team = () => {

                return (
                        <>
                        <div className="section">
                                <div className="container">
                                        <div style={{paddingTop: 100, paddingBottom: 100}}>
                                                <Row gutter={15} align="middle">
                                                        <Col sm={10}>
                                                                <div className="home-team">
                                                                        <img src="/images/home-team.png" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        <Col sm={10} offset={2}>
                                                                <h2>
                                                                        Passionate, Experienced<br/>Campaign Masters
                                                                </h2>
                                                                <p>
                                                                Our team, a blend of seasoned marketing professionals, is deeply passionate about delivering top-tier campaigns. Their expertise and enthusiasm for overcoming marketing challenges ensure tailored strategies that resonate with your brand, driving impactful results and exceeding expectations.
                                                                </p>
                                                        </Col>
                                                </Row>

                                               
                                        </div>
                                </div>
                        </div>
                        
                        </>
                )
        }

        
        const readytogrow = () => {

                return (
                        <>
                        <div className="section">
                                <div className="container">
                                        <div style={{paddingTop: 0, paddingBottom: 100}}>
                                                <h2 style={{textAlign: 'center'}}>
                                                        Ready to start growing<br/>your business?
                                                </h2>
                                                <p style={{margin: '0 auto', maxWidth: 800, textAlign: 'center'}}>
                                                        We can't wait to start working with you, click below to start building your package by telling
                                                        us a little about who you're targeting, where they are and how much you want to invest.
                                                </p>
                                                <div style={{textAlign: 'center', marginTop: 50}}>
                                                <Button onClick={() => navigate('/builder')} style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                }} type="primary">Build your package <FiArrowRight style={{marginLeft: 5}}/> </Button>
                                                        <Button type="blackoutline">Get in touch</Button>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        </>
                )
        }

        return (
                <div className="page">
                        { banner() }
                        { headline() }
                        { team() }
                        
                        { reviewItem() }
                        { readytogrow() }
                </div>
        )
}